import React, { Component } from 'react';
import axios from "axios";
import axiosConfig from "../config/axios.config";

class VerifyEmail extends Component {

    constructor() {
        super();
        this.state = {
            message : 'Verifying your account, please wait...'
        }
    }

    componentWillReceiveProps(nextProps) {

    }
    componentDidMount() {
        let userObjId = this.props.match.params.userObjId
        let token = this.props.match.params.token
        axios.get(`${axiosConfig.apiUrl}/rt/console/verifyUserEmail/${userObjId}/${token}`)
        .then(response => {
            let value = response.data.message
            this.setState({message:value})
        }).catch(error => {
          //console.log("error",error.response)
          this.setState({message:error.response.data.message})
        });
    }
    render() {
        //console.log("VerifyEmail props", this.props);
        //console.log(" user object id", this.props.match.params.userObjId);
        return(
            <div  className="emailVerified">
                <p style={{marginTop: '2em', fontSize: '22px', textAlign:"center"}}>
                    {this.state.message}
                </p>
                <div style={{textAlign:"center"}} id="VerifyloginPageLink">
                    <a href="/">Go to Login Page</a>
                </div>

            </div>
        )
    }
}


export default VerifyEmail
